export default __webpack_public_path__ + "static/media/alert-warning.0d215e04.svg";